import React from 'react';
import FadeInOnScroll from '../common/FadeInOnScroll';
import OptimizedImage from '../common/OptimizedImage';
import { CONTACT_INFO, COMPANY_INFO } from '../../constants';
import contactUsImg from '../../assets/images/contactus.png';
import mapImg from '../../assets/images/map.png';

const ContactSection = () => {
  return (
    <section 
      id="contact-section" 
      className="w-full min-h-screen flex flex-col lg:flex-row text-white px-6 lg:px-24 py-12 lg:py-20 font-aventa relative overflow-hidden font-bold"
    >
      {/* Left Section */}
      <FadeInOnScroll className="flex-1 flex flex-col justify-center space-y-8 relative z-20">
        <OptimizedImage
          src={contactUsImg}
          alt="Contact Us - Maifloer Technologies"
          className="w-full max-w-[30rem] h-auto"
          priority
        />
        
        <div className="space-y-6 text-base text-white/90">
          <div>
            <h3 className="font-bold">Phone</h3>
            <p>{CONTACT_INFO.phone}</p>
          </div>
          <div>
            <h3 className="font-bold">Email</h3>
            <p>{CONTACT_INFO.email}</p>
          </div>
          <div>
            <h3 className="font-bold">Office</h3>
            <p className="font-bold">{CONTACT_INFO.address}</p>
          </div>
        </div>
      </FadeInOnScroll>

      {/* Right Section */}
      <FadeInOnScroll className="flex-1 lg:mt-0 flex justify-center items-center relative z-20 mt-6">
        <div 
          className="w-full h-[400px] lg:h-[500px] max-w-[30rem] overflow-hidden shadow-lg cursor-pointer transition-transform hover:scale-105"
          style={{ borderRadius: '3rem' }}
          onClick={() => window.open('https://maps.app.goo.gl/aastbu3cfrzeXu9p9?g_st=aw', '_blank')}
        >
          <OptimizedImage
            src={mapImg}
            alt="Maifloer Location Map"
            className="w-full h-full object-cover"
            style={{ borderRadius: '3rem' }}
          />
        </div>
      </FadeInOnScroll>
      
      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0 text-center py-4 text-white/70 text-sm z-30">
        <p>{COMPANY_INFO.copyright}</p>
      </div>
    </section>
  );
};

export default ContactSection;